// Pure diff between the local snapshot and the server manifest.
export const versionKey = (d) => `${d?.contentHash || "nohash"}:${d?.metaSig || ""}`;

export function diffManifest(localDocs, remoteDocs) {
  const local = new Map();
  for (const d of localDocs || []) if (d?.docId) local.set(d.docId, versionKey(d));
  const added = [];
  const changed = [];
  const seen = new Set();
  for (const d of remoteDocs || []) {
    if (!d?.docId) continue;
    seen.add(d.docId);
    if (!local.has(d.docId)) added.push(d.docId);
    else if (local.get(d.docId) !== versionKey(d)) changed.push(d.docId);
  }
  const removed = [...local.keys()].filter((id) => !seen.has(id));
  return { added, changed, removed, unchanged: seen.size - added.length - changed.length };
}

export function chunkArray(arr, size) {
  const out = [];
  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
  return out;
}
